export default "__VITE_ASSET__Dj0m_YVM__"